// Human-facing display name for a portal slug.
//
// The canonical form stored in Cosmos `document_registry.portal` is a
// lowercase slug (e.g. `sun-holdings`, `hgi`, `orca`). The UI needs a
// readable label. Known slugs map to curated names; unknown slugs fall
// back to title-case ("foo-bar" → "Foo Bar").

const KNOWN = {
  aduro: "Aduro",
  agora: "Agora",
  apex: "Apex",
  buligo: "Buligo",
  citco: "Citco",
  harbor: "Harbor",
  hgi: "HGI",
  intralinks: "Intralinks",
  moonfare: "Moonfare",
  orca: "Orca",
  "sun-holdings": "Sun Holdings",
  sun_holdings: "Sun Holdings",
};

export function portalDisplayName(slug) {
  if (!slug) return "";
  const known = KNOWN[slug];
  if (known) return known;
  // Fallback: title-case with word boundaries on `-` and `_`
  return String(slug)
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
}
